import type { LayoutTemplateModel } from '@models/types'

type CanvasStyleParams = {
  layoutTemplate: LayoutTemplateModel,
  zoom: number,
}

const calculateCanvasStyle = (params: CanvasStyleParams) => {
  const {
    layoutTemplate: {
      dimensions,
      previews,
    },
    zoom,
  } = params

  return {
    width: dimensions ? dimensions.pixels.width * zoom : 0,
    height: dimensions ? dimensions.pixels.height * zoom : 0,
    backgroundImage: (previews && previews.large) ? `url(${previews.large})` : null,
  }
}

type UseCanvasOptions = {
  layoutTemplate: LayoutTemplateModel,
  zoom: number,
}

function useCanvas(options: UseCanvasOptions) {
  const { layoutTemplate, zoom } = options

  const canvasStyle = calculateCanvasStyle({ layoutTemplate, zoom })

  return {
    canvasStyle,
  }
}

export default useCanvas
